"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function FolderRibbon32Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "32px", height: "32px", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "folder-ribbon-32", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M18,11 L18,9 L27.9964447,9 L27.9964447,11 L18,11 Z M11.2949809,6 L13.4848633,8.99865723 L16,8.99865723 L16,10.9986572 L12.4688926,10.9986572 L10.2790102,8 L6,8 L6,24 L25.9910889,24 L25.9910889,9.71484375 L27.9910889,9.71484375 L27.9910889,26 L4,26 L4,6 L11.2949809,6 Z M20,10 L20,18.0991627 L21.5001149,17.1591812 L23,18.1403872 L23,13.0450439 L25,13.0450439 L25,19.9599614 C24.9711959,20.2541842 24.9711959,20.2541842 24.8342282,20.51617 C24.5270427,20.985738 23.8973595,21.1173751 23.4277914,20.8101896 L21.4768894,19.533934 L19.555473,20.7379056 C19.3002972,20.8660933 19.3002972,20.8660933 19.016,20.8929614 C18.4548787,20.8929614 18,20.4380828 18,19.8769614 L18,10 L20,10 Z", id: "Combined-Shape", fill: "#000000", fillRule: "nonzero" })));
}
function FolderRibbon32(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(FolderRibbon32Svg, Object.assign({}, svgProps)));
}
exports.default = FolderRibbon32;
//# sourceMappingURL=FolderRibbon32.js.map